import type { ReactNode } from 'react';
import styles from './Kbd.module.css';

/** True on macOS, where the modifier is ⌘ rather than Ctrl. Read once — a session
 *  does not change platform, and reading it per render costs a layout query. */
export const IS_MAC =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.userAgent);

/** The primary modifier, spelled the way the user's own keyboard spells it. */
export const MOD_KEY = IS_MAC ? '⌘' : 'Ctrl';

interface KbdProps {
  readonly children: ReactNode;
  /** On a coloured surface — the palette footer, a solid banner. */
  readonly inverse?: boolean;
}

export function Kbd({ children, inverse = false }: KbdProps): ReactNode {
  return <kbd className={`${styles.kbd} ${inverse ? styles.inverse : ''}`}>{children}</kbd>;
}

interface KeysProps {
  /** e.g. `['Ctrl', 'K']` or `['g', 'j']`. Rendered as separate keycaps. */
  readonly keys: readonly string[];
  readonly inverse?: boolean;
}

export function Keys({ keys, inverse = false }: KeysProps): ReactNode {
  return (
    <>
      {keys.map((key) => (
        <Kbd key={key} inverse={inverse}>
          {key}
        </Kbd>
      ))}
    </>
  );
}
